import { Trans } from "@lingui/macro";
import { FC } from "react";
import { StyledButton, StyledOutOfStock } from "./OutOfStock.styled";
import { CloseButton } from "src/atoms/CloseButton";

interface Props {
  brandSlug?: string;
  onClose: () => void;
  genderId?: string;
}

const OutOfStock: FC<Props> = ({ brandSlug, onClose, genderId }) => (
  <StyledOutOfStock>
    <CloseButton className="OutOfStock__close" onClick={onClose} />
    <div className="OutOfStock__title">
      <Trans>Out of stock</Trans>
    </div>
    <div className="OutOfStock__text">
      <Trans>
        We’re really sorry, but it seems like this item is out of stock.
      </Trans>
    </div>
    {brandSlug && genderId && (
      <StyledButton
        variant="tertiary"
        as="a"
        data-testid="continue-shopping-link"
        href={`/brands/${genderId}/${brandSlug}`}
      >
        <Trans>Continue shopping</Trans>
      </StyledButton>
    )}
  </StyledOutOfStock>
);

export default OutOfStock;
